import { z } from 'zod';
import { requestIdSchema, timestampSchema, apiResponseType } from '@repo/shared/types';
export var loanResponseBaseSchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: apiResponseType,
});
// Response code 500
export var internalErrorResponseSchema = z
    .object({
    data: z.object({
        errorDescription: z.string(),
    }),
})
    .extend(loanResponseBaseSchema.shape);
// Response code 404
export var loanDataNotFoundResponseSchema = z
    .object({
    data: z.object({
        parameter: z.string(),
        errorDescription: z.string(),
    }),
})
    .extend(loanResponseBaseSchema.shape);
// Response code 400
export var redisKeyNotFoundResponseSchema = z
    .object({
    data: z.object({
        errorDescription: z.string(),
    }),
})
    .extend(loanResponseBaseSchema.shape);
